var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnselectedLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.625C2.22302e-08 4.13316 0.592632 2.70242 1.64752 1.64752C2.70242 0.592632 4.13316 0 5.625 0C7.11684 0 8.54758 0.592632 9.60248 1.64752C10.6574 2.70242 11.25 4.13316 11.25 5.625C11.25 9.375 5.625 15 5.625 15C5.625 15 0 9.375 0 5.625ZM3.28125 5.625C3.28125 6.2466 3.52818 6.84274 3.96772 7.28228C4.40726 7.72182 5.0034 7.96875 5.625 7.96875C6.2466 7.96875 6.84274 7.72182 7.28228 7.28228C7.72182 6.84274 7.96875 6.2466 7.96875 5.625C7.96875 5.0034 7.72182 4.40726 7.28228 3.96772C6.84274 3.52818 6.2466 3.28125 5.625 3.28125C5.0034 3.28125 4.40726 3.52818 3.96772 3.96772C3.52818 4.40726 3.28125 5.0034 3.28125 5.625Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnselectedLocation);
export default __webpack_public_path__ + "static/media/unselected_location.5deba4ea9cf384dc010e2576f39b17cd.svg";
export { ForwardRef as ReactComponent };